// extracted by mini-css-extract-plugin
export default {"risk-assessment":"DmgYn9MJ_BNfEwsQ6Uy_","component-list":"IQH1JF_9009VGQlW3PCK"};